/** The vendors module's part of the admin dashboard (`dashboard.tiles` / `dashboard.tasks` slots). */

import { useQuery } from "@tanstack/react-query";

import { adminVendorsCounts } from "@motolynk/api-client";
import { DashboardTask } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";
import { KpiTile } from "@motolynk/ui";

import { vendorKeys } from "./shared";

function useCounts() {
  return useQuery({
    queryKey: vendorKeys.counts(),
    queryFn: async () => (await adminVendorsCounts()).data,
  });
}

export function VendorsTile() {
  const { t } = useTranslation("vendors");
  const counts = useCounts().data;
  return (
    <KpiTile
      icon="store"
      label={t("dashboard.vendors")}
      value={counts ? counts.approved : "—"}
      hint={
        counts
          ? t("dashboard.vendorsHint", { count: counts.pending + counts.under_review })
          : undefined
      }
    />
  );
}

export function VendorTasks() {
  const { t } = useTranslation("vendors");
  const counts = useCounts().data;
  return (
    <>
      <DashboardTask
        to="/vendors?status=pending"
        icon="store"
        label={t("dashboard.newApplications")}
        count={counts?.pending}
      />
      <DashboardTask
        to="/vendors?status=under_review"
        icon="store"
        label={t("dashboard.inReview")}
        count={counts?.under_review}
        tone="warning"
      />
    </>
  );
}
